import React from 'react'

import theme from 'theme'
import { MinusV2, PlusV2 } from 'components/Icons'

import UnitQuantityInput from './UnitQuantityInput'
import { QuantityBtnWrapper, QuantityControlsWrapper } from './styles'

export const CONTROLS_VARIANT = {
  DEFAULT: 'default',
  DARK_BLUE: 'darkBlue',
}

const VARIANT_CONFIG = {
  [CONTROLS_VARIANT.DEFAULT]: {
    color: theme.colors.secondary,
    bgColor: theme.colors.lightGrey,
  },
  [CONTROLS_VARIANT.DARK_BLUE]: {
    color: theme.colors.primary,
    bgColor: '#f3f4f6',
  },
}

const QuantityControls = ({
  product,
  unitData,
  disabled,
  quantity,
  onQuantityChange,
  minValue,
  variant = CONTROLS_VARIANT.DEFAULT,
}) => {
  const handleQuantityChange = newValue => {
    if (newValue < minValue) {
      onQuantityChange(minValue)
    } else {
      onQuantityChange(newValue)
    }
  }

  const variantConfig = VARIANT_CONFIG[variant]

  return (
    <QuantityControlsWrapper $bgColor={variantConfig.bgColor}>
      <QuantityBtnWrapper
        data-test-id={`minus_${product.id}`}
        disabled={disabled || quantity === minValue}
        onClick={() => handleQuantityChange(quantity - 1)}
      >
        <MinusV2 color={variantConfig.color} />
      </QuantityBtnWrapper>
      <UnitQuantityInput
        data-test-id={`input_${product.id}`}
        unitData={unitData}
        value={quantity}
        onBlur={handleQuantityChange}
        disabled={disabled}
        variantConfig={variantConfig}
      />
      <QuantityBtnWrapper
        data-test-id={`plus_${product.id}`}
        disabled={disabled}
        onClick={() => handleQuantityChange(quantity + 1)}
      >
        <PlusV2 color={variantConfig.color} />
      </QuantityBtnWrapper>
    </QuantityControlsWrapper>
  )
}

export default QuantityControls
